import { GTMPageCategory } from '../lib/types';

const mapPathnameToPageCategory: Record<GTMPageCategory, string[]> = {
  homepage: ['/'],
  'product selector page': ['/catalog', '/catalog/*', '/collections', '/collections/*'],
  'product detail page': ['/product/*'],
  appendix: [
    '/info',
    '/info/*',
    '/legal',
    '/legal/*',
    '/help',
    '/help/*',
    '/addresses',
    '/contacts',
    '/contacts/*',
    '/vacancies',
    '/vacancies/*'
  ],
  blog: ['/blog', '/blog/*'],
  actions: ['/sales', '/sales/*'],
  cart: ['/cart', '/cart/*'],
  checkout: ['/checkout', '/checkout/*'],
  'content page': [],
  'content page::branding page': ['/about', '/about/*'],
  online: ['/online', '/online/*'],
  'internal search': ['/search'],
  'my account': ['/account', '/account/*'],
  'error page': ['/404', '/500', '/not-found', '/not-found/*'],
  others: []
};

/**
 * Отдает категорию страницы по пути
 * Ищем самый длинный путь, который начинается с пути из маппинга
 * /path === /path/
 * /path/* === /path/...
 */
export const getPageCategory = (pathname: string): GTMPageCategory => {
  const normalize = (value: string) => {
    if (!value) return '/';
    const lower = value.toLowerCase();
    if (lower === '/') return '/';
    return lower.replace(/\/+$/, '');
  };

  const normalizedPathname = normalize(pathname);

  const matchPattern = (pattern: string): number | null => {
    const isWildcard = pattern.endsWith('/*');
    const base = normalize(isWildcard ? pattern.slice(0, -2) : pattern);

    if (isWildcard) {
      if (normalizedPathname === base || normalizedPathname.startsWith(base + '/')) {
        return base.length;
      }
      return null;
    }

    return normalizedPathname === base ? base.length : null;
  };

  let bestCategory: GTMPageCategory | null = null;
  let bestLength = -1;

  const entries = Object.entries(mapPathnameToPageCategory) as [
    GTMPageCategory,
    string[]
  ][];

  entries.forEach(([category, patterns]) => {
    if (!patterns.length) return;
    patterns.forEach((pattern) => {
      const matchLength = matchPattern(pattern);
      if (matchLength !== null && matchLength > bestLength) {
        bestLength = matchLength;
        bestCategory = category;
      }
    });
  });

  const result = bestCategory ?? 'others';

  return result;
};
